<template>
  <v-card>
    <v-card-text>
      <strong>Account Information</strong><br>
      <br>
      <v-text-field label="First Name" v-model="user.first_name" :rules="[rules.required]"></v-text-field>
      <v-text-field label="Last Name" v-model="user.last_name" :rules="[rules.required]"></v-text-field>
      <v-text-field label="Company" v-model="user.company_name"></v-text-field>
      <v-text-field label="Email Address" v-model="user.email" type="email" :rules="[rules.email]"></v-text-field>

      <br>
      <strong>Change Password</strong>
      <v-text-field label="New Password" v-model="password" type="password"></v-text-field>
      <v-text-field label="Confirm Password" v-model="confirm_password" type="password" :rules="[rules.passwordMustMatch]"></v-text-field>
    </v-card-text>
    <v-card-actions>
      <v-btn flat @click="saveUser()">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import api from '@/api/gungho'
import Events from '@/api/events'

export default {
  computed: {
    user () {
      return this.$store.state.user
    }
  },

  data () {
    return {
      password: null,
      confirm_password: null,
      rules: {
        required: (value) => !!value || 'Required',
        email: (value) => {
          /* eslint-disable no-useless-escape */
          const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid Email Address'
        },
        passwordMustMatch: (value) => this.confirm_password === this.password || 'Passwords must match'
      }
    }
  },

  methods: {
    saveUser () {
      var data = {
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        company_name: this.user.company_name,
        password: this.password,
        password_confirmation: this.confirm_password
      }
      api.userUpdate(data).then(data => {
        Events.$emit('toast', 'Saved Account Information')
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// login-info.vue?0d656798